import {FeatureType, SearchEntity, SearchQuery} from '../../generated/types';
import {buildUrl} from '../../lib/routes';

export type SearchHitData = SearchQuery['searchResult']['groups'][number]['hits'][number];

/** Особенность ведёт на саму особенность внутри класса, подкласса или вида */
function featureHref(hit: SearchHitData): string {
	const featureId = hit.id;
	const id = hit.classId || '';
	if (hit.subClassId) return buildUrl('subClassFeature', {id, subClassId: hit.subClassId, featureId});
	if (hit.specieId) return buildUrl('specieFeature', {id: hit.specieId, featureId});
	switch (hit.featureType) {
		case FeatureType.Invocation:
			return buildUrl('classInvocationFeature', {id, featureId});
		case FeatureType.Maneuver:
			return buildUrl('classManeuverFeature', {id, featureId});
		case FeatureType.Metamagic:
			return buildUrl('classMetaMagicFeature', {id, featureId});
		case FeatureType.WildMagic:
			return buildUrl('classWildMagicFeature', {id, featureId});
		case FeatureType.ArcaneShot:
			return buildUrl('classArcaneShotFeature', {id, featureId});
		default:
			return buildUrl('classFeature', {id, featureId});
	}
}

/** Адрес страницы найденной записи */
export function searchHitHref(hit: SearchHitData): string {
	switch (hit.entity) {
		case SearchEntity.Class:
			return buildUrl('class', {id: hit.id});
		case SearchEntity.SubClass:
			return buildUrl('subClass', {id: hit.classId || '', subClassId: hit.id});
		case SearchEntity.Feature:
			return featureHref(hit);
		case SearchEntity.Specie:
			return buildUrl('specie', {id: hit.id});
		case SearchEntity.Origin:
			return buildUrl('origin', {id: hit.id});
		case SearchEntity.Feat:
			return buildUrl('feat', {id: hit.id});
		case SearchEntity.Spell:
			return buildUrl('spell', {id: hit.id});
		case SearchEntity.Item:
			return buildUrl('item', {id: hit.id});
		case SearchEntity.Monster:
			return buildUrl('monster', {id: hit.id});
		case SearchEntity.BookChapter:
			return buildUrl('bookChapter', {bookId: hit.bookId || '', chapterId: hit.id});
		case SearchEntity.BookSection:
			return `${buildUrl('bookChapter', {bookId: hit.bookId || '', chapterId: hit.chapterId || ''})}#${hit.id}`;
		case SearchEntity.NameSet:
			return buildUrl('namesSet', {id: hit.id});
		case SearchEntity.Page:
			return hit.href || '/';
		case SearchEntity.WikiArticle:
			return buildUrl('wikiArticle', {id: hit.id});
		case SearchEntity.GlossaryItem:
			return buildUrl('glossaryItem', {id: hit.id});
		default:
			return buildUrl('search', {q: hit.title});
	}
}
